import { Badge } from '@/components/ui/badge';

const colourStyles: Record<string, string> = {
  gray: 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-200',
  blue: 'bg-blue-100 text-blue-700 dark:bg-blue-800 dark:text-blue-200',
  amber: 'bg-amber-100 text-amber-700 dark:bg-amber-800 dark:text-amber-200',
  purple:
    'bg-purple-100 text-purple-700 dark:bg-purple-800 dark:text-purple-200',
  indigo:
    'bg-indigo-100 text-indigo-700 dark:bg-indigo-800 dark:text-indigo-200',
  green: 'bg-green-100 text-green-700 dark:bg-green-800 dark:text-green-200',
  red: 'bg-red-100 text-red-700 dark:bg-red-800 dark:text-red-200',
  slate: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200',
  violet:
    'bg-violet-100 text-violet-700 dark:bg-violet-800 dark:text-violet-200',
  stone: 'bg-stone-100 text-stone-700 dark:bg-stone-800 dark:text-stone-200',
  cyan: 'bg-cyan-100 text-cyan-700 dark:bg-cyan-800 dark:text-cyan-200',
  mauve: 'bg-mauve-100 text-mauve-700 dark:bg-mauve-800 dark:text-mauve-200',
  pink: 'bg-pink-100 text-pink-700 dark:bg-pink-800 dark:text-pink-200',
};

type StatusBadgeProps = {
  label: string;
  colour: string;
  pulse?: boolean;
  className?: string;
};

export default function StatusBadge({
  label = 'unknown',
  colour = 'gray',
  pulse = false,
  className = '',
}: StatusBadgeProps) {
  const styles = colourStyles[colour] ?? '';

  return (
    <Badge variant={'outline'} className={`${styles} ${className}`}>
      {pulse && (
        <span className="relative mr-1 flex h-1.5 w-1.5">
          <span className="absolute inline-flex h-full w-full rounded-full bg-current opacity-75 motion-safe:animate-ping" />
          <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-current" />
        </span>
      )}
      {label}
    </Badge>
  );
}
